import { render, staticRenderFns } from "./dailyBenefits.vue?vue&type=template&id=260f0e08&scoped=true&"
import script from "./dailyBenefits.vue?vue&type=script&lang=js&"
export * from "./dailyBenefits.vue?vue&type=script&lang=js&"
import style0 from "./dailyBenefits.vue?vue&type=style&index=0&id=260f0e08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260f0e08",
  null
  
)

export default component.exports